import { lineAmount } from '../../utils/quotationPricing';
export function recordQuotationForNeed(state, need, quotation) {
  if (!quotation?._id) throw new Error('Le devis doit être enregistré avant de rattacher le besoin.');
  if (state.quotes.some(row => row.apiQuotationId === quotation._id)) return state;
  const versions = state.quotes.filter(row => row.needId === need.id);
  const products = quotation.products || [];
  const primary = products.find(product => product.type !== 'Prime') || products[0] || {};
  const quote = {
    id: quotation._id, apiQuotationId: quotation._id, quotationNumber: quotation.quotationNumber,
    needId: need.id, clientId: need.clientId, version: Math.max(0, ...versions.map(row => row.version || 0)) + 1,
    status: 'créé', job: need.job, qty: need.qty, createdAt: quotation.createdAt || new Date().toISOString(),
    validUntil: String(quotation.expiryDate || '').slice(0, 10), rate: primary.taux,
    coefficient: primary.coefficient, amount: products.reduce((total, product) => total + lineAmount(product), 0),
    conditions: products.map(product => product.comment).filter(Boolean).join(' '), products,
  };
  return { ...state, quotes: [...state.quotes, quote],
    tasks: state.tasks.map(task => task.needId === need.id && task.category === 'quote' ? { ...task, done: true, completedAt: quote.createdAt } : task) };
}
